/**
 * Checks if value is within constraints
 * If conditions are met, the same value is returned
 * If lower, the lowerLimit is returned
 * If higher, the upperLimit is returned
 * 
 * @param {Number} value 
 * @param {Number} lowerLimit 
 * @param {Number} upperLimit 
 */
const ValueWithinConstraints = (value, lowerLimit, upperLimit) => {
    if (value > lowerLimit) {
        if (value < upperLimit) {
            return value;
        } else {
            return upperLimit;
        }
    } else {
        return lowerLimit;
    }
} 

export default ValueWithinConstraints;